// React
import React from 'react';

// Utilities
import {
    useActivityHelpers,
    useLabels,
    useContext,
    useInitiativeAndReportData,
} from 'utilities/hooks';

// Packages

// Data

// Components
import SectionContainer from 'components/_report/templates/report_5_0_pdf/sectionContainer';
import Collection from 'components/_report/templates/report_5_0_pdf/collection';
import { ReportUpdate } from 'components/_report/templates/report_5_0_pdf/_cards';

const SectionActivitiesComponent = ({
    utilities,
    items: navigationItems,
    CONSTANTS,
    wrapCardContents = true,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { REPORT_ID } = useContext();
    const { label } = useLabels();
    const { legacyMode } = useInitiativeAndReportData();
    const { getTypeLabels, getCardComponent } = useActivityHelpers();

    // ///////////////////
    // DATA
    // ///////////////////

    const reflectionIds = utilities.reportDetails
        .getTypeActivityOverviewFromReportId(REPORT_ID)
        .map(reflection => reflection.Initiative_Activity__c);

    // Get items with reflection
    const items = legacyMode
        ? utilities.activities.getAll()
        : utilities.activities
              .getAll()
              .filter(item => reflectionIds.includes(item.Id))
              .sort(
                  (a, b) =>
                      new Date(b.LastModifiedDate) -
                      new Date(a.LastModifiedDate)
              );

    const navigationItem = navigationItems[0] ?? {};

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <div className="flex flex-col space-y-24">
            <SectionContainer
                {...{
                    item: navigationItem,
                }}>
                <Collection
                    {...{
                        collection: {
                            items,
                            emptyLabel: label(
                                'EmptyStateWizardPageActivitiesBasic'
                            ),
                        },
                        card: {
                            preTitle(item) {
                                return getTypeLabels(item.Id).type;
                            },
                            title(item) {
                                return item?.Things_To_Do__c;
                            },
                            postTitle(item) {
                                return getTypeLabels(item.Id).subType;
                            },
                            components(item) {
                                const Component = getCardComponent(item.Id);
                                const cardContent = Component ? (
                                    <Component
                                        {...{
                                            item,
                                            theme: 'blue',
                                            utilities,
                                            CONSTANTS,
                                        }}
                                    />
                                ) : null;
                                return {
                                    cardContent,
                                    reportUpdate(additinalProps) {
                                        return (
                                            <ReportUpdateActivity
                                                {...{
                                                    additinalProps,
                                                    item,
                                                    CONSTANTS,
                                                    utilities,
                                                }}
                                            />
                                        );
                                    },
                                };
                            },
                        },
                    }}
                />
            </SectionContainer>
        </div>
    );
};

const ReportUpdateActivity = ({
    additinalProps,
    item,
    CONSTANTS,
    utilities,
    showStatus = false,
}) => {
    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <ReportUpdate
            {...{
                ...additinalProps,
                utilities,
                CONSTANTS,
                ...(showStatus
                    ? {
                          status: {
                              item,
                              relationKey: 'Initiative_Activity__c',
                              type: CONSTANTS.REPORT_DETAILS.ACTIVITY_OVERVIEW,
                          },
                      }
                    : {}),
                metrics: {
                    item,
                },
                reflection: {
                    item,
                    relationKey: 'Initiative_Activity__c',
                    type: CONSTANTS.REPORT_DETAILS.ACTIVITY_OVERVIEW,
                },
            }}
        />
    );
};

SectionActivitiesComponent.propTypes = {};

SectionActivitiesComponent.defaultProps = {};

export default SectionActivitiesComponent;
